import {Route, Switch, Redirect} from 'react-router-dom';
import React from 'react';

import {innerParticipantRoutes} from './participantsRoutes';
import DirectoryMessage from '../screens/EventDirectory/DirectoryMessage';
import EventDirectory from '../screens/EventDirectory/EventDirectory';
import EventExhibitors from '../screens/EventExhibitors/EventExhibitors';
import LoadExhibitors from '../loaders/LoadExhibitors';
import LoadParticipants from '../loaders/LoadParticipants';
import mapRoutes from './mapRoutes';
import  {scheduleItemRoutes}  from './scheduleRoutes';

export default props => (
    <LoadExhibitors {...props.match.params}>
        <LoadParticipants {...props.match.params}>
            <Switch>
                <Route path={`${props.match.path}`} exact component={EventExhibitors} />
                <Route path={`${props.match.path}/:path+/program/:itemId`} component={scheduleItemRoutes} />
                <Route path={`${props.match.path}/:path*/participants`} component={innerParticipantRoutes} />
                <Route path={`${props.match.path}/:path*/message`} component={DirectoryMessage} />
                <Route path={`${props.match.path}/:path*/map`} component={mapRoutes} />
                <Route path={`${props.match.path}/:path*`} component={EventDirectory} />
                <Redirect to={`${props.match.path}`} />
            </Switch>
        </LoadParticipants>
    </LoadExhibitors>
);
